<template>
  <div class="saved-card">
    <slot/>

    <SavedCard :card="value" hide-title />

    <div class="row">
      <div class="col-sm-9">
        <b-form-group class="row compact" label="Saved Card Options:" label-for="title">
          <div class="required">
            <input v-model="value.title" id="title" type="text" class="form-control" placeholder="Description of card" v-validate="'required'" required/>
          </div>
          <PrivateToggle v-model="is_private" noun="card" />
        </b-form-group>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">
.card-brand{
  width: 48px;
  height: 30px;
}
</style>

<script>
import SavedCard from "./SavedCard.vue";

export default {
  components: {SavedCard},
  props: ['value'],
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  },
  computed: {
    is_private: {
      get() { return !this.value.available_to_team; },
      set(value) { this.value.available_to_team = !value; }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/billing/EditSavedCard.vue